module.exports = __webpack_public_path__ + "std/img/login-copper.99dbc0a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/login-copper.webp
// module id = pJb8
// module chunks = 0